import { SET_IS_AUTHORIZED_FOR_REPAIRS } from 'actions';

export function setIsAuthorizedForRepairs(isAuthorizedForRepairs: boolean) {
  return { isAuthorizedForRepairs, type: SET_IS_AUTHORIZED_FOR_REPAIRS };
}
